"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconButton = _interopRequireDefault(require("./../../IconButton/IconButton"));
var _MoreVertical = _interopRequireDefault(require("@ellucian/ds-icons/lib/MoreVertical"));
var _Tooltip = _interopRequireDefault(require("./../../Tooltip/Tooltip"));
/**
 * Icon button component for Action menu
 */
var ActionMenuIconButton = function ActionMenuIconButton(props) {
  var _IconButtonProps$aria;
  var id = props.id,
    edsContext = props.edsContext,
    icon = props.icon,
    IconButtonProps = props.IconButtonProps,
    open = props.open,
    setOpen = props.setOpen,
    buttonRef = props.buttonRef,
    title = props.title;
  var tooltipTitle = title != null ? title : edsContext.formatMessage('component.ActionMenu.more');
  var ariaLabel = (_IconButtonProps$aria = IconButtonProps == null ? void 0 : IconButtonProps['aria-label']) != null ? _IconButtonProps$aria : tooltipTitle;
  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: tooltipTitle
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, (0, _extends2.default)({
    ref: buttonRef,
    disableRipple: true,
    "aria-expanded": open,
    "aria-haspopup": "true",
    "aria-controls": id,
    onClick: setOpen,
    color: "gray",
    tabIndex: 0
  }, IconButtonProps, {
    "aria-label": ariaLabel
  }), icon));
};
ActionMenuIconButton.propTypes = {
  buttonRef: _propTypes.default.object,
  open: _propTypes.default.bool,
  setOpen: _propTypes.default.func,
  /**
   * @ignore
   */
  edsContext: _propTypes.default.object,
  icon: _propTypes.default.node,
  /**
   * Menu HTML ID for uniqueness.
   */
  id: _propTypes.default.string,
  /**
   * Props applied to the IconButton that brings up the action menu
  */
  IconButtonProps: _propTypes.default.object,
  /**
   * @ignore
   *
   * Externally set the initial open state of the action menu. For testing purposes only.
   */
  initialOpenOverride: _propTypes.default.bool,
  /**
   * The tooltip title override applied to the internal IconButton.
   * This value is also applied to the aria-label of the IconButton, unless one is already provided via IconButtonProps.
   */
  title: _propTypes.default.string
};
ActionMenuIconButton.defaultProps = {
  icon: /*#__PURE__*/_react.default.createElement(_MoreVertical.default, null)
};
var _default = exports.default = ActionMenuIconButton;